import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-move-list-item',
    templateUrl: './move-list-item.dialog.html',
    styleUrls: ['./move-list-item.dialog.scss'],
    standalone: false
})
export class MoveListItemDialog implements OnInit {
    public title: string;
    public message: string;
    public showMoveOrRepositionPrompt: boolean;
    public repositionDisabledMsg: any;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
        this.showMoveOrRepositionPrompt = data.showMoveOrRepositionPrompt;
        this.message = data.message;
        this.repositionDisabledMsg = data.repositionDisabledMsg;
    }

    ngOnInit(): void {}

    public get RepositionDisabledMsg(): string {
        if (this.repositionDisabledMsg) {
            return this.repositionDisabledMsg;
        } else {
            return 'Re-order the Folder at the current Folder level';
        }
    }

}
